export default __webpack_public_path__ + "static/media/indoor-8.89b905af.png";